import arc from './arc.js'
import * as d3 from 'd3-selection'
import pointer from './pointer.js'
import thresholds from './thresholds.js'
import thresholdByValue from './threshold-by-value.js'

const padding = {
  top: 10,
  bottom: 7
}

export default function (id, dim) {
  var centerX = (dim.width / 2) + dim.padding.left
    , centerY = dim.viewbox.height + padding.top + (dim.width / 2)

  var draw = function (selection) {
    selection.each(function (data) {
      var defs = d3.select(this).select('defs')
        , gauge = d3.select(this)
                     .selectAll('g.gauge-row').data([data])

      var startAngle = -90
      if (data.thresholds && data.thresholds[0] > data.thresholds[1]) {
        // If there are thresholds in descending order, then the start angle is 90, and the arc
        // will go from right to left
        startAngle = 90
      }

      let row = gauge.enter()
                     .append('g')
                       .attr('class', 'gauge-row')
                       .merge(gauge)

      let value = data.value
        , _thresholds = data.thresholds || [0, 1]
        , onRotate = (angle, value) => {
          let thresholdLookup = thresholdByValue(data.colors, value, _thresholds)
          row.call(arc(id, defs, dim, startAngle), _thresholds, value, data.highlightArcThreshold, thresholdLookup)
        }
        , onEnd = () => {
          // Pointer transition has ended, make sure the data is updated correctly
          row.call(arc(id, defs, dim, startAngle), _thresholds, value, data.highlightArcThreshold)
        }

      row.attr('transform', 'translate(' + centerX + ',' + centerY + ')')
         .call(thresholds(id, defs, dim, startAngle))
         .call(arc(id, defs, dim, startAngle), _thresholds, value && value.raw,data.highlightArcThreshold)
         .call(pointer(id, defs, dim, startAngle, onRotate, onEnd))
    })

    // Adjust the viewbox height based on what we're drawing.
    // We also add some additional height in pointer.js.
    dim.viewbox.height += (padding.top + (dim.width / 2) + padding.bottom)
  }

  return draw
}
